import { PbError } from '@owner/errors'

class BadRequestError extends PbError {
  constructor(args) {
    super(args.message, args)
    this.name = 'BadRequestError'
    this.code = args.code
    this.message = args.message
    this.status = args.status
  }
}

export { BadRequestError }
